import React from 'react';
import CustomerContactInfoComp from './CustomerContactInfoComp';

const CustomerContactInfoAdditionalAddress = props =>
  (
<CustomerContactInfoComp
  {...props}
  autoComplete="address-line2"
  errorMessages={{
    'field_is_required': 'The additional address field is required',
    'field_is_invalid': 'Your additional address field is invalid',
  }}
  label="Additional Address field"
  name="additionalAddress"
/>
  );

export default CustomerContactInfoAdditionalAddress;
